export const CLOSE_ADD_SEASON_MODAL_BUTTON_LABEL = "Close";
export const DAY_PICKER_DETAILS =
  "The chosen year does not have an impact on the date selected";

export const ADD_SEASON_MODAL_HEADER = "Add Season";
export const ADD_SEASON_NAME_INPUT_LABEL = "Season Name";
export const ADD_SEASON_BUTTON_LABEL = "Add";



// WEBPACK FOOTER //
// ./src/pages/director/seasons/components/seasons-editor/components/add-season-modal/constants.ts